const overlay: Record<string, string> = {
  50: '#0000000a',
  100: '#00000014',
  200: '#00000033',
  300: '#0000004d',
  400: '#00000061',
  500: '#00000080',
  550: '#0000008a',
  600: '#00000099',
  700: '#000000b3',
  800: '#000000cc',
  900: '#000000de',
};

export default overlay;
